export enum DROPDOWN_ACTION {
   COUNTRY = 'COUNTRY',
   STATE = 'STATE',
   CITY = 'CITY'
}
